import { useStore } from "../utils/mobx.utils";
export var useObservableRef = function (initialValue) {
    var ref = useStore(function () { return ({
        _current: initialValue || null,
        get current() { return ref._current; },
        set current(el) { ref._current = el; }
    }); });
    return ref;
};
